import React from 'react';
const items = require('./productsDatabase.json');



class Products extends React.Component {
    constructor(){
        super()
        this.state = {
           productsList: items
        };
        this.handleclick=this.handleclick.bind(this); // look up bind | creates a new function spec the "this"
        // on this function
    }


    handleclick = (event) => { // listener
        if(event.target.value === "All Prices") { // setting state to filter by the price prop in the JSON file
            this.setState({productsList: items});
        } else if (event.target.value === "Under $200") {
            this.setState({productsList: items.filter(product => product.price < 200)});
        } else if (event.target.value === "$200-$1000") {
            this.setState({productsList: items.filter(product => product.price >= 200 && product.price <= 1000)});
        } else if (event.target.value === "$1000+") {
            this.setState({productsList: items.filter(product => product.price > 1000)});
        }

        if(event.target.value === "All") {
            this.setState({productsList: items});
        } else if (event.target.value === "livingroom") {
            this.setState({productsList: items.filter(product => product.category === "livingroom")});
        } else if (event.target.value === "bedroom") {
            this.setState({productsList: items.filter(product => product.category === "bedroom")});
        } else if (event.target.value === "office") {
            this.setState({productsList: items.filter(product => product.category === "office")});
        }

    }


    render() {
        return (
            //React.Fragment 
            //insert header to footer 
            // inside div grid with products, bring in products.json
            // file 
            <React.Fragment>


    <main>
        <section className="heroText"><h2>ZEN HOME</h2></section>
        <div className="grid-container">


        <ol class="filters">
            <li>FILTER BY:</li>
            <li>
              <button value="All" onClick={this.handleclick}>All Rooms(12)</button>
            </li>
            <li>
              <button value="livingroom" onClick={this.handleclick}>Living Room(4)</button>
            </li>
            <li>
              <button value="bedroom" onClick={this.handleclick}>Bedroom(4)</button>
            </li>
            <li>
              <button value="office" onClick={this.handleclick}>Office(4)</button>
            </li>
            <li>
              <button value="All Prices" onClick={this.handleclick}>All Prices(12)</button>
            </li>
            <li>
              <button value="Under $200" onClick={this.handleclick}>Under $200(4)</button>
            </li>
            <li>
              <button value="$200-$1000" onClick={this.handleclick}>$200-$1000(4)</button>
            </li>
            <li>
              <button value="$1000+" onClick={this.handleclick}>$1000+(4)</button>
            </li>
          </ol>
     
    

            <div className="products-grid">
                    {this.state.productsList.map((products, key) => {
                        return (
                            <div>
                            <section className="product">
                            <img src={products.img} alt="items" height="250" width="250" className="center-img"/>
                            <h2>{products.name}</h2>
                            <p className="p-price">${products.price}</p>
                            <div className="p-description">{products.description}</div>
                            <button>ADD TO CART</button>
                    </section>
                    </div>
                    )
                    })} 
            </div>
         </div>
    </main>

            </React.Fragment>
        )
    }
}

export default Products;